import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';

import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

import Home from './pages/user/Home';
import Cart from './pages/user/Cart';
import Checkout from './pages/user/Checkout';
import Orders from './pages/user/Orders';
import Profile from './pages/user/Profile';
import EditProfile from './pages/user/EditProfile';

import AdminDashboard from './pages/admin/Dashboard';
import ProductManagement from './pages/admin/ProductManagement';
import Adminmanagement from './pages/admin/Adminmanagement';
import OrderManagement from './pages/admin/OrderManagement';
import RiderManagement from './pages/admin/RiderManagement';
import AddEditProduct from './pages/admin/AddEditProduct';
import RiderEarnings from './pages/admin/RiderEarnings';

import RiderDashboard from './pages/rider/RiderDashboard';
import RiderOrders from './pages/rider/RiderOrders';
import RiderDelivered from './pages/rider/RiderDelivered';

import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';

import './App.css';
import AdminManagement from './pages/admin/Adminmanagement';

function AppContent() {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="app">
      {user && <Navbar />}
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to={getRoleRoute(user.role)} />} />
        <Route path="/register" element={!user ? <Register /> : <Navigate to={getRoleRoute(user.role)} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/user/*" element={
          <ProtectedRoute allowedRoles={['user']}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-profile" element={<EditProfile />} />
            </Routes>
          </ProtectedRoute>
        } />

        <Route path="/admin/*" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Routes>
              <Route path="/" element={<AdminDashboard />} />
              <Route path="/products" element={<ProductManagement />} />
              <Route path="/products/add" element={<AddEditProduct />} />
              <Route path="/products/edit/:id" element={<AddEditProduct />} />
              <Route path="/orders" element={<OrderManagement />} />
              <Route path="/riders" element={<RiderManagement />} />
               <Route path="/rider-earnings" element={<RiderEarnings />} />
               <Route path="/admins" element={<AdminManagement />} />
            </Routes>
          </ProtectedRoute>
        } />

        <Route path="/rider/*" element={
          <ProtectedRoute allowedRoles={['rider']}>
            <Routes>
              <Route path="/" element={<RiderDashboard />} />
              <Route path="/orders" element={<RiderOrders />} />
              <Route path="/delivered" element={<RiderDelivered />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-profile" element={<EditProfile />} />
            </Routes>
          </ProtectedRoute>
        } />

        <Route path="/" element={
          user ? <Navigate to={getRoleRoute(user.role)} /> : <Navigate to="/login" />
        } />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

function getRoleRoute(role) {
  switch (role?.toLowerCase()) {
    case 'admin': return '/admin';
    case 'rider': return '/rider';
    default: return '/user';
  }
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;